module.exports = __webpack_public_path__ + "img/iconjuego.ef94bdcc.png";